export function Footer() {
  return (
    <footer className="relative border-t border-white/[0.06] py-14">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-6 md:flex-row md:items-end">
        <div>
          <div className="flex items-center gap-2 text-lg font-semibold tracking-tight">
            <span className="inline-block h-2 w-2 rounded-full bg-electric shadow-[0_0_12px_var(--electric)]" />
            Nithin Devadiga
          </div>
          <div className="mt-2 text-sm text-muted-foreground">
            Future AI Founder · Software Engineer · SaaS Builder
          </div>
        </div>
        <div className="text-sm text-muted-foreground md:text-right">
          <p className="italic text-foreground/80">"Every great company starts as an idea."</p>
          <p className="mt-3 text-xs">© {new Date().getFullYear()} Nithin Devadiga</p>
        </div>
      </div>
    </footer>
  );
}
